import { PropsWithChildren } from 'react';

import { AppType } from '@ingrid/luterkort-react/dist/DropdownMenu/AppSwitcherComposite';

import { PermissionsContext } from '../contexts/PermissionsContext';
import { useGetUserQuery } from '../queries';

export const TransportRoles = ['transport:view', 'transport:edit'] as const;

export type TransportRole = (typeof TransportRoles)[number];

export const APP_ROLES: Record<AppType, string[]> = {
  checkout: ['mad:site-config', 'mad:experiments', 'mad:checkout-widget'],
  tracking: ['tracking-feature:view', 'mad:tracking_numbers', 'mad:tracking-widget'],
  instore: [
    'instore:admin',
    'instore:pcp',
    'instore:cnc',
    'instore:super-user',
    'instore:support',
    'instore:store-manager',
  ],
  transport: ['transport:view'],
  settings: ['mad:users'],
};

export function PermissionProvider({ children }: PropsWithChildren) {
  const { data: user } = useGetUserQuery();

  const userRoles = user?.roles?.map(r => r.name).filter(r => r !== undefined) ?? [];

  function hasRole(roles: string[]) {
    if (user?.super_user) {
      return true;
    }

    return roles.every(p => userRoles.includes(p));
  }

  return <PermissionsContext.Provider value={{ roles: userRoles, hasRole }}>{children}</PermissionsContext.Provider>;
}
